import configs from '@@ting/configs'

export const fileURL = (path: string) => `${configs.app.fileServer}${path}`
